var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var CreateBironexForm = function (props) {
    return (_jsxs("div", __assign({ className: "payment-information" }, { children: [_jsxs("ul", { children: [_jsxs("li", { children: [_jsx("div", __assign({ className: "title" }, { children: "\u041D\u043E\u043C\u0435\u0440 \u0447\u0435\u043A\u0430:" })), _jsx("div", { className: "dashed" }), _jsx("div", __assign({ className: "value" }, { children: props.pin }))] }), _jsxs("li", { children: [_jsx("div", __assign({ className: "title" }, { children: "\u041D\u043E\u043C\u0438\u043D\u0430\u043B:" })), _jsx("div", { className: "dashed" }), _jsxs("div", __assign({ className: "value" }, { children: [props.amount, " OPX"] }))] }), _jsxs("li", { children: [_jsx("div", __assign({ className: "title" }, { children: "\u041E\u0431\u043C\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u0440\u0441:" })), _jsx("div", { className: "dashed" }), _jsx("div", __assign({ className: "value" }, { children: "1 OPX = 1 USD" }))] }), _jsxs("li", { children: [_jsx("div", __assign({ className: "title" }, { children: "\u041A \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044E:" })), _jsx("div", { className: "dashed" }), _jsxs("div", __assign({ className: "value" }, { children: [props.amount, " USD"] }))] })] }), _jsx("br", {}), _jsx("div", __assign({ className: 'controls' }, { children: props.fetching ? (_jsx("button", { disabled: true, className: "loading" })) : (_jsx("button", __assign({ type: 'button', onClick: function () { return props.handleCreate(); } }, { children: "\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C" }))) }))] })));
};
CreateBironexForm.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    fetching: PropTypes.bool.isRequired,
    pin: PropTypes.string,
    handleCreate: PropTypes.func.isRequired,
};
export default CreateBironexForm;



// WEBPACK FOOTER //
// ./src/components/recharge/forms/CreateBironexForm.jsx